
const TypeMap: any = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
  default: ''
}

export { TypeMap }
